import React from "react";
import {
  COMMUNICATION_INTEGRATION_KINDS,
  CommunicationIntegration,
} from "@/types/communication-integration";
import { IntegrationCard } from "./IntegrationCard";

interface IntegrationsListProps {
  hotelId: string;
  integrations: CommunicationIntegration[];
}

export const IntegrationsList: React.FC<IntegrationsListProps> = ({
  hotelId,
  integrations,
}) => (
  <div className="flex flex-col gap-4">
    {COMMUNICATION_INTEGRATION_KINDS.map((kind) => {
      const row = integrations.find((it) => it.kind === kind) ?? null;
      return (
        <IntegrationCard
          key={kind}
          hotelId={hotelId}
          kind={kind}
          integration={row}
        />
      );
    })}
  </div>
);
